// Generated file : do not modify
import { ObjTypes } from '@/generated/classes/ObjTypes';
import { NotifDefTypes } from '@/generated/classes/NotifDef';
import { storeSession } from '@/generated/stores';
import { type AxiosResponse } from 'axios';
import ListData from '@/extend/classes/ListData';
import {getRequestConfig} from "@/framework/base/helpers/HttpHelper.ts";

// Machines à état
export default class State  {
  // Identifiant unique
  public id: number;
  // Objet de rattachement
  public objType: ObjTypes;
  // Objet de rattachement
  public objId: number;
  // Etat courant
  public statut: number;
  // Libellé de l'état courant
  public statutEnum: string;
  // Text HTML associé à l'état courant
  public info: string;
  // Libellé des actions associées à l'état courant
  public actions: string[];
  // Affichage outlined des actions
  public outlined: boolean[];
  // Action demandée par l'utilisateur (0 si aucune)
  public actionIndex: number;
  // Text HTML associé à l'état courant
  public infoHtmlId: number;
  // Donnée pouvant être  modifiée
  public canUpdate: boolean;
  // Donnée pouvant être supprimée
  public canDelete: boolean;
  // Display des objets
  public display: string;
  // Type de notification
  public notifDefType: NotifDefTypes;

  constructor() {
    this.id = 0;
    this.objType = ObjTypes.NONE;
    this.objId = 0;
    this.statut = 0;
    this.statutEnum = '';
    this.info = '';
    this.actions = [];
    this.outlined = [];
    this.actionIndex = 0;
    this.infoHtmlId = 0;
    this.canUpdate = true;
    this.canDelete = true;
    this.display = '';
    this.notifDefType = NotifDefTypes.NONE;
  }

  public static fromJson (obj: State): State {
    const newState: State = new State();
    newState.id = obj.id;
    newState.objType = obj.objType;
    newState.objId = obj.objId;
    newState.statut = obj.statut;
    newState.statutEnum = obj.statutEnum;
    newState.info = obj.info;
    newState.actions = JSON.parse(JSON.stringify(obj.actions));
    newState.outlined = JSON.parse(JSON.stringify(obj.outlined));
    newState.actionIndex = obj.actionIndex;
    newState.infoHtmlId = obj.infoHtmlId;
    newState.canUpdate = obj.canUpdate;
    newState.canDelete = obj.canDelete;
    newState.display = obj.display;
    newState.notifDefType = obj.notifDefType;
    return newState;
  }

  public toJsonState (): string {
    const json = {
      objType: this.objType,
      objId: this.objId,
      statut: this.statut,
      statutEnum: this.statutEnum,
      info: this.info,
      actions: this.actions,
      outlined: this.outlined,
      actionIndex: this.actionIndex,
      infoHtmlId: this.infoHtmlId,
      canUpdate: this.canUpdate,
      canDelete: this.canDelete,
      notifDefType: this.notifDefType,
    }
    return JSON.stringify(json);
  }

  public fromState (obj: State): void {
    this.id = obj.id;
    this.objType = obj.objType;
    this.objId = obj.objId;
    this.statut = obj.statut;
    this.statutEnum = obj.statutEnum;
    this.info = obj.info;
    this.actions = obj.actions;
    this.outlined = obj.outlined;
    this.actionIndex = obj.actionIndex;
    this.infoHtmlId = obj.infoHtmlId;
    this.canUpdate = obj.canUpdate;
    this.canDelete = obj.canDelete;
    this.display = obj.display;
    this.notifDefType = obj.notifDefType;
  }

  public compareState (value: State): boolean {
    return (this.toJsonState() == value.toJsonState());
  }

  public cloneState (): State {
    return State.fromJson(this);
  }

  public static process (state: State): Promise<State> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/states/process', state, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(State.fromJson(res.data));
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  // eslint-disable-next-line
  public static getDate(states: State[]) {
  }
}
